import axios from './index'

export default {
  fetchPaginate(type, params) {
    return axios.get(`/api/v1/review/paginate/${type}`, { params })
  },
  fetch(type, params) {
    return axios.get(`/api/v1/review/${type}`, { params })
  },
}